import { useState, useEffect } from 'react';

/**
 * useViewportWidth — current window.innerWidth, updated on resize. Used by the
 * board header to priority-collapse (hide low-priority labels) as it narrows
 * so its controls never overlap. Walter 2026-06-24.
 */
export default function useViewportWidth() {
  const [w, setW] = useState(() => (typeof window !== 'undefined' ? window.innerWidth : 1024));
  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const on = () => setW(window.innerWidth);
    window.addEventListener('resize', on);
    return () => window.removeEventListener('resize', on);
  }, []);
  return w;
}
